import {
  readStructuredRaw, writeStructuredRaw, writeLinksOfType,
  EMPTY_SCHEDULE, type TopicDetails, type ScheduleStructured,
} from '@/types/topic';
import { ScheduleForm } from '@/pages/Topics/structured/ScheduleForm';

/**
 * Meeting schedule editor. Stores the schedule in the __structured__ blob
 * (kind: schedule) and mirrors the ICS URL to a `metadata` link so the app's
 * link-based reader can find it.
 */
export function ScheduleContentField({ details, onChange }: {
  details: TopicDetails;
  langs: string[];
  onChange: (d: TopicDetails) => void;
}) {
  const raw = readStructuredRaw(details);
  const value = { ...EMPTY_SCHEDULE, ...raw } as ScheduleStructured;

  const set = (s: ScheduleStructured) => {
    let next = writeStructuredRaw(details, { ...s, kind: 'schedule' });
    const ics = s.ics_url ? [{ url: s.ics_url, name: 'calendar', type: 'metadata' }] : [];
    next = writeLinksOfType(next, 'metadata', ics);
    onChange(next);
  };

  return <ScheduleForm value={value} onChange={set} />;
}
